import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { LayoutGrid } from "lucide-react"
import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
} from "@/components/ui/sheet"
import { Switch } from "@/components/ui/switch"

import { useEngineStore } from "../stores/use-engine-store"

/**
 * ChatSettingsTrigger - 聊天设置触发按钮
 * 
 * 独立的触发按钮组件，可放置在任何位置
 * 通过 store 状态控制 Sheet 的打开
 */
export function ChatSettingsTrigger() {
    const { open } = useEngineStore(s => s.chatSettings)

    return (
        <Button
            variant='ghost'
            size='sm'
            className='text-muted-foreground hover:bg-muted h-8 w-8 px-0 md:h-8 md:w-auto md:gap-1.5 md:px-3 md:text-xs'
            title='聊天设置'
            onClick={open}
        >
            <LayoutGrid className='size-4 md:size-3.5' />
            <span className='hidden md:inline'>聊天设置</span>
        </Button>
    )
}

/**
 * ChatSettingsSheet - 聊天设置面板
 * 
 * 独立的 Sheet 内容组件，应放置在组件树的稳定位置（如根布局）
 * 使用受控模式，不依赖 trigger 的存在
 */
export function ChatSettingsSheet() {
    const {
        isOpenBackgroundImg,
        setIsOpenBackgroundImg,
        isUseCoverAsBackground,
        setIsUseCoverAsBackground,
        currentEngine
    } = useEngineStore(s => s.engine)
    const { mode, setMode } = useEngineStore(s => s.mode)
    const { isOpen, setIsOpen } = useEngineStore(s => s.chatSettings)

    // 判断是否有封面图可用
    const hasCoverURL = !!currentEngine?.coverURL

    return (
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetContent>
                <SheetHeader>
                    <SheetTitle>聊天设置</SheetTitle>
                    <SheetDescription>
                        根据您的喜好设置当前会话的内容
                    </SheetDescription>
                </SheetHeader>
                <div className="grid flex-1 auto-rows-min gap-6 px-4">
                    <div className="grid gap-3">
                        <Label htmlFor="engine-background">是否开启背景</Label>
                        <div className="flex items-center space-x-2">
                            <Switch id="engine-background" checked={isOpenBackgroundImg} onCheckedChange={setIsOpenBackgroundImg} />
                            <Label htmlFor="engine-background">{isOpenBackgroundImg ? '开启背景' : '关闭背景'}</Label>
                        </div>
                    </div>
                    <div className="grid gap-3">
                        <Label htmlFor="cover-as-background">背景图来源</Label>
                        <div className="flex items-center space-x-2">
                            <Switch
                                id="cover-as-background"
                                checked={isUseCoverAsBackground}
                                onCheckedChange={setIsUseCoverAsBackground}
                                disabled={!hasCoverURL}
                            />
                            <Label htmlFor="cover-as-background">
                                {!hasCoverURL ? '无封面图' : (isUseCoverAsBackground ? '使用封面图' : '使用原始背景')}
                            </Label>
                        </div>
                    </div>
                    <div className="grid gap-3">
                        <Label htmlFor="engine-mode">启用哪种模式进行游玩</Label>
                        <div className="flex items-center space-x-2">
                            <Switch id="engine-mode" checked={mode === 'chat'} onCheckedChange={(value) => value ? setMode('chat') : setMode('galgame')} />
                            <Label htmlFor="engine-mode">{mode === 'chat' ? '聊天模式' : ' Galgame 模式'}</Label>
                        </div>
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    )
}


